<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
router.replace({
  name: 'login',
  query: {
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VyIjoiR0xKTEsiLCJpc3MiOiJTbWFydEFzc2lzdGFudCIsImV4cCI6MTcwMTk3MDMzOSwibmJmIjoxNjk4MzcwMzM5LCJpYXQiOjE2OTgzNzAzMzl9.QrM4QtFZyuW7Flv8een85KdUJypPGoON6yIBSJjnuz4',
    cwid: 'GLJLK',
  },
})
</script>

<template></template>
